import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import parse from "html-react-parser"
import Typography from "aldoo-ra/Typography"
import PlatformsAvailable from "../PlatformsAvailable"
import TopRightPageBg from "../TopRightPageBg"

const MoreDictionariesHeader = () => {
  return (
    <div className="relative w-full bg-gradient_header overflow-hidden">
      <CMSRender
        contentType="PageSectionHeader"
        match={{ "content.name": "MoreDictionariesHeader" }}
        renderItem={(data, id) => {
          return (
            <div
              key={id}
              className="w-full md:max-w-[700px] lg:max-w-w2_xl flex flex-col lg:flex-row items-center justify-between gap-[10px] px-4 md:px-px1_xl lg:pr-0 pt-10 lg:pb-10 mx-auto"
            >
              {/* Left Section */}
              <div className="flex flex-col items-center lg:items-start w-full lg:w-[45%] lg:max-w-[640px]">
                {/* Title */}
                <Typography
                  variant="h1"
                  className="text-text text-center lg:text-left mb-5"
                >
                  {parse(data.title)}
                </Typography>

                {/* Store Button */}
                {data.button?.[0]?.link?.[0]?.url && (
                  <a
                    href={data.button[0].link[0].url}
                    target="_blank"
                    rel="noreferrer"
                    className="w-[190px] h-[55px] flex items-center p-0 hover:opacity-90 transition-opacity mb-5"
                  >
                    <img
                      src={data.button[0].image}
                      alt={data.button[0].description}
                      className="w-full h-full object-cover"
                    />
                  </a>
                )}

                {/* Platforms Available */}
                <PlatformsAvailable
                  selectedPlatform="android"
                  variant="centered"
                  data={data}
                />
              </div>

              {/* Right Section - Image */}
              <div className="w-full lg:w-[60%] max-w-[710px] aspect-706/565">
                <img
                  src={data.image}
                  alt={data.imageAlt || "Dictionary apps showcase"}
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          )
        }}
      />

      <TopRightPageBg />
    </div>
  )
}

export default MoreDictionariesHeader
